import { Link, useLocation } from "react-router-dom";
import { FileText } from "lucide-react";

export default function StickyQuote() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin") || pathname === "/contact") return null;

  return (
    <Link
      to="/contact"
      className="fixed bottom-6 right-6 z-40 group"
      data-testid="sticky-quote-button"
      aria-label="Get a free quote"
    >
      <div className="flex items-center gap-3 bg-red-600 hover:bg-red-700 text-white px-5 py-4 rounded-sm shadow-xl transition-all duration-200 hover:shadow-2xl hover:-translate-y-0.5">
        <FileText className="w-5 h-5" />
        <span className="font-semibold text-sm tracking-wide">Get a Free Quote</span>
      </div>
    </Link>
  );
}
